import { extendTheme } from '@chakra-ui/react';
import {
  BG_ALTERNATIVE,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  BG_OPACITY,
  ASSETS_PRIMARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    body: FONT_FAMILY.body,
    body_lv2: FONT_FAMILY.body_lv2,
    and: FONT_FAMILY.and,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '32px',
    body: '19px',
    body_lv2: '17px',
    and: '66px',
  },
  fontWeights: {
    heading: 400,
    body: 500,
    body_lv2: 500,
    and: 300,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
        '--fontItalic-and': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(244,233,218,1)',
    bgSecondary: 'rgba(159,134,96,1)',
    mainAssetColor: 'rgba(96,78,56,1)',
    bgAlternative: '#FFFFFF',
    bgOpacity: '#323030',
    mainColorText: 'rgba(159,134,96,1)',
    secondaryColorText: 'rgba(109,108,5,1)',
    alternativeColorText: '#FEFEFE',
    transparent: 'transparent',
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
    Button: {
      baseStyle: {
        fontFamily: 'subHeading',
      },
    },
  },
};

export default extendTheme(theme);
